import { useState } from 'react'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import CloseIcon from '@mui/icons-material/Close'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'
import { reExportedColors, ITooltip } from '../../index'
import Slider from '../../Icons/svg/sliders.svg'

export default function FilterButton ({ columns, setColumns }) {
  const [isOptTabOpen, setIsOptTabOpen] = useState(false)
  const hasHiddenColumns = columns.some((column) => column.isShown === false)

  const handleTabOpen = () => {
    setIsOptTabOpen(!isOptTabOpen)
  }

  const selectAll = () => {
    const filterSettingsCopy = [...columns]
    filterSettingsCopy.forEach((filterSetting) => {
      filterSetting.isShown = true
    })
    setColumns(filterSettingsCopy)
  }

  const handleToggle = (index) => {
    const newColumns = columns.slice()
    newColumns[index].isShown = !columns[index].isShown
    setColumns(newColumns)
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <ITooltip content='Filter' placement='top'>
        <Box
          alt='Filter'
          component='img'
          onClick={handleTabOpen}
          src={Slider}
          sx={{
            background: hasHiddenColumns ? reExportedColors.YELLOW : undefined,
            borderRadius: 1,
            cursor: 'pointer',
            height: 30,
            marginLeft: '8px',
            padding: '4px',
            width: 30,
            '&:hover': {
              background: reExportedColors.HOVER,
              height: 30,
              width: 30
            }
          }}
        />
      </ITooltip>

      {isOptTabOpen && (
        <Box
          sx={{
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            borderRadius: '6px',
            boxShadow: '0px 5px 5px 5px #00000029',
            fontFamily: 'Roboto',
            minWidth: '200px',
            padding: 'auto 20px 15px 10px',
            position: 'absolute',
            right: '5px',
            top: '35px',
            zIndex: 5
          }}
        >
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              marginLeft: '15px'
            }}
          >
            <Box
              onClick={selectAll}
              sx={{
                cursor: 'pointer',
                fontFamily: 'roboto',
                fontSize: 12,
                textDecoration: 'underline'
              }}
            >
              Select All
            </Box>
            <IconButton aria-label='Close column filter' onClick={handleTabOpen}>
              <CloseIcon />
            </IconButton>
          </Box>

          <List sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {columns.map((value, index) => (
              <ListItem
                dense
                key={index}
                onClick={() => handleToggle(index)}
                role={undefined}
                sx={{
                  height: '25px',
                  justifyContent: 'flex-start',
                  maxWidth: '150px',
                  overflowWrap: 'break-word',
                  width: '100%',
                  '& .MuiListItemText-primary': { fontSize: '12px' }
                }}
              >
                <ListItemIcon sx={{ minWidth: '30px' }}>
                  <Checkbox
                    checked={value.isShown}
                    color='default'
                    disableRipple
                    edge='start'
                    tabIndex={-1}
                  />
                </ListItemIcon>
                <ListItemText
                  id={value}
                  primary={value.column || value.headerName}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  )
}
